import { icuPicker, icuPickerT3312, mintedUpcPicker } from "@lib/index";
import {
  blitzCosmetics,
  blitzNonCosmetics,
  fillColorsonicHairCareAndColor,
  fillEssieMaybelline,
  fillHairCareAndColor,
  fillLorealNyx,
} from "./beauty";
import { TSurveyFeature } from "./types";

// const SKIN_CARE_REGEX = /(Skin.Care|Care.Skin)/i;
// const HAIR_COLOR_REGEX = /(Hair.Color|Color.Hair)/i;

export const SURVEY_FEATURES = [
  {
    regex: /essie.Maybelline Maintenance|Maybelline.essie Maintenance/i,
    featureName: "Essie & Maybelline Fill",
    callback: fillEssieMaybelline,
  },
  {
    regex: /NYX( Maintenance)?.L'Oreal( Maintenance)?|L'Oreal( Maintenance)?.NYX( Maintenance)?/i,
    featureName: "Loreal & Nyx Fill",
    callback: fillLorealNyx,
  },
  {
    regex: /Colorsonic.Color.(Skin.Care|Care.Skin) Maint/i,
    featureName: "ColorSonic, Hair care & Color Fill",
    callback: fillColorsonicHairCareAndColor,
  },
  {
    regex: /(?=.*Color)(?=.*Care)(?=.*Thayers)(?=.*Skin)/i,
    featureName: "Hair care & Color Fill",
    callback: fillHairCareAndColor,
  },
  {
    regex: /Minted \d(-\d)? FT POG/i,
    featureName: "Minted OOS Picker",
    callback: mintedUpcPicker,
  },
  {
    regex: /ICU Eyecare/i,
    featureName: "T3312 ICU Picker",
    callback: icuPickerT3312,
  },
  {
    regex: /Blitz[\W]+Cosmetics/i,
    featureName: "Blitz Cosmetics",
    callback: blitzCosmetics,
  },
  {
    regex: /Blitz[\W]+Non[\W]+Cosmetics/i,
    featureName: "Blitz Non Cosmetics",
    callback: blitzNonCosmetics,
  },
  {
    regex: /ICU Eyecare Core WITH Wink/i,
    featureName: "ICU Eyecare Core WITH Wink",
    callback: icuPicker,
  },
] satisfies TSurveyFeature[];
